export default __webpack_public_path__ + "static/media/continuous.09b39dc3.jpg";